import { render } from "./RgpdVue.vue?vue&type=template&id=671f6552&scoped=true"
const script = {}

import "../assets/css/rgpd.css?vue&type=style&index=0&id=671f6552&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671f6552"]])

export default __exports__